// extracted by mini-css-extract-plugin
export default {"searchBox":"Grid_searchBox__Vf3Rg","table":"Grid_table__V3wT7"};